// -----------------------------------------------------------------------------
// MAIN JAVASCRIPT FILE
// Theme initialization - simple and organized
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// CORE MODULES
// Essential theme functionality
// -----------------------------------------------------------------------------
import { initNavigation } from "./theme/_menu";

// -----------------------------------------------------------------------------
// THEME FEATURES
// Import and organize theme functionality
// -----------------------------------------------------------------------------
import { stickyHeader, stickySidebar } from "./theme/_header";
import { siteSearch } from "./theme/_search";
import { fadeAnimations } from "./theme/_animations";
import { openExternalLinks, scrollToPageTop, lightbox } from "./theme/_base.js";

// -----------------------------------------------------------------------------
// INITIALIZATION FUNCTIONS
// Group related functionality for clarity
// -----------------------------------------------------------------------------
const initBaseFeatures = () => {
  initNavigation(); // Initialize menu and navigation
  openExternalLinks(); // Handle external links and PDFs
  siteSearch(); // Initialize search functionality
  stickySidebar(); // Setup sticky sidebar behavior
};

const initInteractiveFeatures = () => {
  fadeAnimations(); // Scroll animations
  lightbox(); // Gallery lightbox
};

// -----------------------------------------------------------------------------
// DOM READY: INITIALIZE ALL THEME FEATURES
// -----------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  initBaseFeatures(); // Core utility functions
  initInteractiveFeatures(); // Interactive elements
});

// -----------------------------------------------------------------------------
// WINDOW SCROLL: HANDLE SCROLL-BASED FEATURES
// -----------------------------------------------------------------------------
window.addEventListener("scroll", function () {
  stickyHeader(); // Update header positioning

  // Conditional scroll features
  if (document.querySelector(".cd-top")) {
    scrollToPageTop();
  }
});
